import * as React from 'react'
import ProductsListView from './ProductListView'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { IQuestionnaire, QuestionnaireStatus } from '../../../Model/Questionnaire'
import { Link } from 'react-router-dom'
import { getProductsSum } from '../../../Helpers/ProductHelper'
// import * as Moment from 'moment'
// import DateTimeHelper from '../../Helpers/DateTimeHelper'

export interface IProductDetailsViewProps {
    className?: string
    questionnaire: IQuestionnaire,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class ProductDetailsView extends React.Component<IProductDetailsViewProps> {

    render() {
        const { questionnaire, localizationStore } = this.props

        if (!questionnaire || !questionnaire.credit || !questionnaire.credit.creditNumber) {
            return ('')
        }

        return (
            <div className={this.props.className}>
                <div className="container">

                    <div className="row">
                        <p>{localizationStore!.t!('products')}</p>
                    </div>

                    <div className="row blockProducts">
                        <ProductsListView className="col-12" products={questionnaire.credit.products} />
                    </div>

                    <div
                        className="row mt-2"
                    >
                        <div
                            className="col-6"
                        >
                            <Link
                                hidden={!(
                                    questionnaire.status === QuestionnaireStatus.InProgressCreditConsultant || 
                                    questionnaire.status === QuestionnaireStatus.InProgressCreditExpert ||
                                    questionnaire.status === QuestionnaireStatus.Delivery ||
                                    questionnaire.status === QuestionnaireStatus.ActiveCredit
                                    )}
                                className="btn btn-success"
                                to={`/editCreditProducts/${questionnaire.id}`}
                            >
                                {localizationStore!.t!('EditTitle')}
                            </Link>
                        </div>

                        <div className="col-6 blockProductsSum">
                            {localizationStore!.t!('totalSum')}
                            <mark>
                                {
                                    getProductsSum(questionnaire.credit.products).toFixed(2)
                                }
                            </mark>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Product/ProductDetailsView.tsx